import API_CONFIG, { api } from './config';

const CASHFLOW_ENDPOINT = '/cashflow';

/**
 * Obtiene la información del cash flow (overview, puede ser diario o mensual según parámetros).
 * Puedes pasar parámetros de filtrado (por ejemplo, rango de tiempo) a través de "params".
 */
const getCashFlow = async (params = {}) => {
  try {
    const response = await api.get(`${API_CONFIG.BASE_URL}${CASHFLOW_ENDPOINT}`, { params });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Obtiene la información del cash flow diario "relleno".
 * Se utilizará el endpoint '/cashflow/daily' para obtener los datos diarios completos.
 */
const getDailyCashFlow = async (params = {}) => {
  try {
    const response = await api.get(`${API_CONFIG.BASE_URL}${CASHFLOW_ENDPOINT}/daily`, { params });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Llama al endpoint para generar insights financieros con Claude.
 */
const generateClaudeInsights = async (params = {}) => {
  try {
    const response = await api.get(`${API_CONFIG.BASE_URL}${CASHFLOW_ENDPOINT}/generate-insights`, { params });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

/**
 * Obtiene el último registro de insight financiero.
 * Se utiliza el endpoint '/cashflow/latest-insight'.
 */
const getLatestInsight = async (params = {}) => {
  try {
    const response = await api.get(`${API_CONFIG.BASE_URL}${CASHFLOW_ENDPOINT}/latest-insight`, { params });
    return response.data;
  } catch (error) {
    throw new Error(API_CONFIG.ERROR_HANDLERS.formatErrorMessage(error));
  }
};

// Creamos un objeto con los métodos y lo asignamos a una variable
const cashFlowService = {
  getCashFlow,
  getDailyCashFlow,
  generateClaudeInsights,
  getLatestInsight,
};

// Exportamos el objeto
export default cashFlowService;